// extracted by mini-css-extract-plugin
export default {"zoomModal":"I2-z","image":"J2-z","button":"K2-z","isOverlayShown":"L2-z"};